import {useEffect, useState} from "react";
import {DeliveryAndPaymentInterface} from "../../../interfaces/api/DeliveryAndPaymentInterface";

export default function Payments({deliveryAndPaymentData}: {
    deliveryAndPaymentData: DeliveryAndPaymentInterface[]
}) {
    const [isShow, setIsShow] = useState(true)

    const getUniquePaymentMethods = () => {
        const paymentMethods = deliveryAndPaymentData.map(item => item.payments).flat().filter(item => item.card_title);
        const uniqueMethods = Array.from(new Set(paymentMethods.map(method => method.card_title)));
        return uniqueMethods.map(name => paymentMethods.find(method => method.card_title === name)).sort( (a, b) => (b?.sort_id || 0) - (a?.sort_id || 0) ) ;
    };

    useEffect(() => {
        console.log('Payments -> ', getUniquePaymentMethods());
    }, [deliveryAndPaymentData]);

    return (<div className={"product__kv-info-cols " + (isShow && "show")}>
        <p className={"product__kv-info-cols-link f-exp " + (isShow && "active")}>Оплата <i className="ico ico-arrow-bot-b" onClick={() => {setIsShow(!isShow)}}></i></p>
        {isShow && <div className="product__kv-info-cols-list">
            <ul>
                {getUniquePaymentMethods().map(payment => <li key={payment?.id}><p><b>{payment?.card_title}</b>{payment?.card_description}</p></li>)}
            </ul>
        </div>}
    </div>)
}